import { ColumnConfig, SupportUserManageAccessColumnKey } from '../model';

export const supportUserManageAccessConfig: Record<
  SupportUserManageAccessColumnKey,
  ColumnConfig
> = {
  access: {
    name: 'Customer Name',
    isCheckboxField: true,
    field: 'checkboxNavigate',
  },
  role: {
    name: 'Role',
    field: 'NavigateLink',
  },
  expiryDate: {
    name: 'Expiry Date',
  },
  accountStatus: {
    name: 'Account Status',
  },
  action: {
    name: 'Action',
    field: 'component',
  },
};
